import * as React from "react";
import { getStarsSuffix } from "../api/yelp";

interface IYelpStarsProps {
    rating: number;
}

const YelpStars = React.memo(({ rating }: IYelpStarsProps) => {
    const suffix = getStarsSuffix(rating);
    const url1x = "/images/yelpstars/small/small_" + suffix + ".png";
    const url2x = "/images/yelpstars/small/small_" + suffix + "@2x.png";
    const url3x = "/images/yelpstars/small/small_" + suffix + "@3x.png";
    const srcset = url3x + " 3x, " + url2x + " 2x, " + url1x + " 1x";
    return <img src={url1x} alt="Yelp rating" srcSet={srcset} />;
});

export default YelpStars;
